export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: "黑料在线的速览内容是怎么选出来的？",
    answer:
      "我们每天追踪公开平台上的话题热度，挑选讨论量明显上涨、且信息来自公开作品或公开活动的议题，再由编辑整理成结论在前的短篇速览。",
  },
  {
    question: "为什么有的热点没有收录？",
    answer:
      "涉及私人生活、非公开个人信息、医疗与财务等敏感议题的内容一律不收录。我们只讨论作品表现、舞台呈现与公开活动本身。",
  },
  {
    question: "热度分值代表什么？",
    answer:
      "热榜上的分值综合了话题讨论量、阅读完成率和近 24 小时的涨幅，用来表示『最近有多热』，并不代表内容的重要性排序。",
  },
  {
    question: "需要注册才能浏览吗？",
    answer:
      "不需要。全部速览内容直接打开即可阅读，不做登录拦截，也不强制跳转外部页面。",
  },
  {
    question: "可以投稿或推荐话题吗？",
    answer:
      "可以。通过『联系我们』页面留言，说明话题与公开来源链接即可，编辑会在 2 个工作日内回复是否适合做成速览。",
  },
  {
    question: "内容多久更新一次？",
    answer:
      "热榜每天 09:00 与 18:00 各更新一次，专题文章按话题节奏不定期补充，重大话题会在当天加更。",
  },
];